import fuzzyLogicSoilAttribute from './fuzzyLogicSoilAttribute';

export const SUSCEPTIBILITY_TO_COMPACTION = fuzzyLogicSoilAttribute({
  fuzzyLogicRuleName: 'SOH - Soil Susceptibility to Compaction',
  key: 'Susceptibility to Compaction',
  ruleId: '2764',
  shortFormData: { AggregationMethod: 'Dominant Condition' },
});
